<template>
  <div class="ma-4 d-flex flex-column align-content-stretch">
    <FlexRow v-if="companyId" align="baseline" class="mb-2">
      <FlexColumn width="400px" class="ml-1 mr-4">
        <SelectField
            v-model="templateId"
            name="テンプレート選択"
            simple
            :outlined="false"
            :items="templateItems"
            @change="handleApplyTemplate"
        />
      </FlexColumn>
      <Button outlined @click="openMessageTemplateListDialog = true">テンプレート一覧</Button>
      <Button outlined @click="openMessageTemplateCreateDialog = true">テンプレート作成</Button>
    </FlexRow>

    <TextArea
        v-model="text"
        simple
        :autoGrow="false"
        :rows="textAreaRows"
        :disabled="messageId == null"
        @input="handleChangeMessage"
    />
    <div class="d-flex flex-column justify-end mt-1">
      <div class="d-flex flex-row align-top justify-space-between">
        <Label size="body-2" :text="attentionText" />
        <div class="d-flex align-center mt-1">
          <div v-if="file">
            {{fileName}}
            <TextButton icon left-icon="mdi-close" @click="onClearFile"/>
          </div>
          <FileSelectButton
              class="mr-2"
              :disabled="messageId == null"
              @input="onSelectFile"
          >
            ファイル選択
          </FileSelectButton>
          <TextButton
              :primary="messageId != null"
              :disabled="messageId == null"
              @click="candidate ? onSend() : onPreSend()"
          >
            メッセージ送信
          </TextButton>
        </div>
      </div>
    </div>
    <MessagePostConfirmDialog
        v-if="!candidate"
        :open="postConfirmDialog"
        :side="side"
        :status="candidateUser.applicationStatus"
        @close="postConfirmDialog = false"
        @post="handlePost"
    />
    <JoinDateFormDialog
        v-if="!candidate"
        :open="openJoinDateDialog"
        :userName="fullName"
        :candidateId="userId"
        :jobId="jobId"
        :status="5"
        @complete="onCompleteJoinDateDialog"
        @cancel="openJoinDateDialog = false"
    />
    <JoinSideJobFormDialog
        v-if="!candidate"
        :open="showSideJobDialog"
        :userName="fullName"
        :jobId="jobId"
        :candidateId="userId"
        :status="5"
        @complete="onCompleteJoinSideJobDialog"
        @cancel="showSideJobDialog = false"
    />
    <JoinCompleteDialog
        v-if="!candidate"
        :open="openJoinCompleteDialog"
        :isSide="side"
        @close="openJoinCompleteDialog = false"
    />
    <MessageTemplateCreateDialog
        :open="openMessageTemplateCreateDialog"
        :companyId="companyId"
        @close="openMessageTemplateCreateDialog = false"
    />
    <MessageTemplateListDialog
      :open="openMessageTemplateListDialog"
      :companyId="companyId"
      @close="openMessageTemplateListDialog = false"
    />
  </div>
</template>

<script>
import TextArea from "@/components/atoms/TextArea";
import TextButton from "@/components/atoms/TextButton";
import FileSelectButton from "@/components/atoms/FileSelectButton";
import ApiMixin from "@/ApiMixin";
import Label from '../atoms/Label'
import MessagePostConfirmDialog from "./MessagePostConfirmDialog";
import JoinDateFormDialog from "./JoinDateFormDialog";
import JoinSideJobFormDialog from "./JoinSideJobFormDialog";
import JoinCompleteDialog from "./JoinCompleteDialog";
import FlexRow from "../atoms/FlexRow";
import Button from "../atoms/Button";
import SelectField from "../atoms/SelectField";
import FlexColumn from "../atoms/FlexColumn";
import MessageTemplateCreateDialog from "./MessageTemplateCreateDialog";
import {mapGetters} from "vuex";
import MessageTemplateListDialog from "./MessageTemplateListDialog";

export default {
  mixins: [ApiMixin],
  type: "organism",
  name: "MessageForm",
  components: {
    MessageTemplateListDialog,
    MessageTemplateCreateDialog,
    FlexColumn,
    SelectField,
    Button,
    FlexRow,
    JoinCompleteDialog,
    JoinSideJobFormDialog,
    JoinDateFormDialog, MessagePostConfirmDialog, Label, FileSelectButton, TextButton, TextArea},
  props: {
    messageId: {
      type: String,
    },
    candidate: {
      type: Boolean
    },
    candidateUser: {
      type: Object
    },
    companyId: {
      type: String
    }
  },
  data () {
    return {
      text: "",
      file: null,
      postConfirmDialog: false,
      openJoinDateDialog: false,
      showSideJobDialog: false,
      openJoinCompleteDialog: false,
      templateId: undefined,
      openMessageTemplateCreateDialog: false,
      openMessageTemplateListDialog: false,
      textAreaRows: 5
    }
  },
  computed: {
    ...mapGetters("message", ["templates"]),
    ...mapGetters("temporary", ["messages"]),
    fileName () {
      if (this.file) {
        return this.file.name
      }
      return null
    },
    attentionText() {
      return this.candidate ? '' : '※「カジュアル面談」の場合お見送りの連絡は不要です'
    },
    side() {
      return this.candidateUser.job.isSide
    },
    status() {
      return this.candidateUser.applicationStatus
    },
    jobId() {
      return this.candidateUser.job.id
    },
    userId() {
      return this.candidateUser.user.id
    },
    fullName () {
      const lastName = this.candidateUser.user.lastName || ""
      const firstName = this.candidateUser.user.firstName || ""
      return lastName + " " + firstName
    },
    templateItems() {
      return this.templates.map(template => ({
        label: template.name,
        value: template.id,
      }))
    }
  },
  methods: {
    onSelectFile(file) {
      this.file = file;
    },
    onClearFile() {
      this.file = null;
    },
    sendUtterance(messageId, text, dataId, option) {
      if (this.candidate) {
        return this.postCandidateUtterance(messageId, text, dataId, option)
      } else {
        return this.postClientUtterance(messageId, text, dataId, option)
      }
    },
    onPreSend() {
      if (this.status === 5) {
        this.onSend()
        return
      }
      this.postConfirmDialog = true
    },
    async handlePost(newStatus) {
      const oldStatus = this.status
      this.postConfirmDialog = false
      if (oldStatus !== newStatus) {
        if (newStatus === 5) {
          if (this.side) {
            this.showSideJobDialog = true
          } else {
            this.openJoinDateDialog = true
          }
          return
        } else {
          await this.applyJobForClient(this.jobId, this.userId, newStatus)
          this.$emit("change:status", {status: newStatus, messageId: this.messageId})
        }
      }
      
      const farewell = newStatus === 6
      const notAddUtterance = oldStatus !== 6 && farewell // 既に「お見送り」になったものには送信できるように
      this.onSend({ notAddUtterance })
    },
    onCompleteJoinDateDialog() {
      this.openJoinDateDialog = false
      this.openJoinCompleteDialog = true
      this.$emit("change:status")
      this.onSend()
    },
    onCompleteJoinSideJobDialog() {
      this.showSideJobDialog = false
      this.openJoinCompleteDialog = true
      this.$emit("change:status")
      this.onSend()
    },
    handleApplyTemplate() {
      const template = this.templates.find(template => template.id === this.templateId)
      if (template) {
        this.text = template.detail
            .replaceAll("{{lastname}}", this.candidateUser.user.lastName)
            .replaceAll("{{firstname}}", this.candidateUser.user.firstName)
            .replaceAll("{{job}}", this.candidateUser.job.name)
      }
    },
    onSend(option) {
      let dataId = null;
      if (this.file) {
        this.postFileData(this.file, true).then(res => {
          this.sendUtterance(this.messageId, this.text, res.data.id, option).then(() => {
            this.text = ""
            this.file = null
            this.$emit("post")
            this.textAreaRows = 5
          })
        })
      } else {
        this.sendUtterance(this.messageId, this.text, dataId, option).then(() => {
          this.text = ""
          this.file = null
          this.$emit("post")
          this.textAreaRows = 5
        })
      }
      this.dispatch("temporary", "deleteMessage", {messageId: this.messageId})
    },
    updateTextAreaRows(value) {
      if (value) {
        const rows = value.split("\n").length
        if (rows > 20) {
          this.textAreaRows = Math.max(this.textAreaRows, 20)
        } else {
          this.textAreaRows = Math.max(this.textAreaRows, rows)
        }
      }
    },
    handleChangeMessage(value) {
      this.updateTextAreaRows(value)
      this.dispatch("temporary", "saveMessage", {messageId: this.messageId, message: value})
    }
  },
  watch: {
    messageId: {
      handler(value) {
        const msg = this.messages.find(item => item.messageId === value)
        this.textAreaRows = 5
        if (msg) {
          this.text = msg.message
          this.updateTextAreaRows(this.text)
        } else {
          this.text = ""
        }
      }
    },
  }
}
</script>

<style scoped>

</style>
